<section>
  <form fxLayout="column"
        fxLayoutAlign="center center"
        fxLayoutGap="10px"
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()">
    <mat-form-field>
      <input type="email"
             matInput
             placeholder="Your email"
             formControlName="email">
      <mat-hint>Please enter a valid email.</mat-hint>
      <mat-error>Invalid or missing email.</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input type="password"
             matInput
             placeholder="Your password"
             formControlName="password">
      <mat-hint>Please enter your password.</mat-hint>
      <mat-error>Missing password.</mat-error>
    </mat-form-field>
    <button type="submit" mat-raised-button color="primary" [disabled]="loginForm.invalid">Submit</button>

    <button (click)="authService.googleLogin()" mat-button ><img src="/images/btn_google_signin_dark_focus_web.png" /></button>


  </form>
</section>
